import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="policy-page">
      <h1>Privacy Policy</h1>
      <p>
        At Lan4ai (www.lan4ai.com), we are committed to protecting your privacy and complying with EU data protection laws (e.g. GDPR).
        We collect and process personal data only as necessary to provide our AI-driven analytics and actionable business insights.
      </p>
      <h2>Data Controller</h2>
      <p>
        Lan4ai is the data controller. For any inquiries regarding your personal data, please contact us at privacy@lan4ai.com.
      </p>
      <h2>What Data We Collect</h2>
      <p>
        We may collect information such as your name, email address, and usage data when you sign up or interact with our services.
      </p>
      <h2>Your Rights</h2>
      <p>
        Under the GDPR, you have the right to access, correct, or request deletion of your personal data.
        You also have the right to object to certain data processing activities.
      </p>
      <p>
        For more details, please review our full policy.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
